import { render, staticRenderFns } from "./_rightPancake3.vue?vue&type=template&id=14038640&scoped=true&"
import script from "./_rightPancake3.vue?vue&type=script&lang=js&"
export * from "./_rightPancake3.vue?vue&type=script&lang=js&"
import style0 from "./_rightPancake3.vue?vue&type=style&index=0&id=14038640&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14038640",
  null
  
)

export default component.exports